
// Videos Widget
import VideosWidget from "../assets/components/videos_widget.vue"
Vue.component('videos-widget', VideosWidget)
